'use client'

import React from 'react'
import { Gift, Keyboard, SaleSquare } from 'solar-icons'
import { cn } from '@/lib/utils'

import {
  Button,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CmdChip,
} from '@/components/ui'

interface FooterActionsBarProps extends React.ComponentPropsWithoutRef<'div'> {
  opts?: any
}

export const FooterActionsBar = ({
  className,
  opts,
  ...restProps
}: FooterActionsBarProps) => {
  return (
    <Carousel
      className={cn('flex w-full overflow-hidden rounded-lg', className)}
      opts={{ slidesToScroll: 2, dragFree: true, ...opts }}
      {...restProps}
    >
      <CarouselContent className="w-full gap-2">
        <CarouselItem className="basis-1/3">
          <Button variant="secondary" className="h-[48px] w-full gap-2 px-3">
            <div className="flex w-full items-center gap-2">
              <Keyboard className="size-5" strokeWidth={1.5} />
              <span className="font-medium">Calculator</span>
            </div>
            <CmdChip variant="white">1</CmdChip>
          </Button>
        </CarouselItem>

        <CarouselItem className="basis-1/3">
          <Button variant="secondary" className="h-[48px] w-full gap-2 px-3">
            <div className="flex w-full items-center gap-2">
              <Gift className="size-5" strokeWidth={1.5} />
              <span className="font-medium">Gift Cards</span>
            </div>
            <CmdChip variant="white">2</CmdChip>
          </Button>
        </CarouselItem>

        <CarouselItem className="basis-1/3">
          <Button variant="secondary" className="h-[48px] w-full gap-2 px-3">
            <div className="flex w-full items-center gap-2">
              <SaleSquare className="size-5" strokeWidth={1.5} />
              <span className="font-medium">Discounts</span>
            </div>
            <CmdChip variant="white">3</CmdChip>
          </Button>
        </CarouselItem>
      </CarouselContent>

      <CarouselPrevious />
      <CarouselNext />
    </Carousel>
  )
}
